import type { KeyboardEvent } from "react";

import validationPatterns from "@ui/utils/validationPatterns";

const alphanumericRegex = new RegExp(validationPatterns.ALPHANUMERIC);

export const restrictToAlphaNumericKey = (e: KeyboardEvent<HTMLInputElement>): boolean => {
  const isAlphanumeric = alphanumericRegex.test(e.key);

  if (!isAlphanumeric) e.preventDefault();

  return isAlphanumeric;
};
